import axios from "axios";


const requestData = async (action, params) => {

    let BaseUrl = ``
    if (process.env.NODE_ENV !== "production") {
        BaseUrl = `http://localhost:8082`
    }

    try {
        const appId = 1;
        const token = localStorage.getItem("auth-token");
        const response = await axios.post(`${BaseUrl}/api/ver1/run`,
            { action, params },
            { headers: { token, appId } }
        );

        return response.data;
    } catch (error) {
        console.error("Error in axiosRequest:", error);
        throw error;
    }
};


const getFile = async (params) => {

    // console.log(params)
    let BaseUrl = ``
    if (process.env.NODE_ENV !== "production") {
        BaseUrl = `http://localhost:8082`
    }

    try {
        const appId = 1;
        const token = localStorage.getItem("auth-token");
        const response = await axios.post(`${BaseUrl}/api/file`,
            { params },
            { headers: { token, appId } }
        );

        return response.data;
    } catch (error) {
        console.error("Error in axiosRequest:", error);
        throw error;
    }
};


const fetch = async (url) => {

    try {
        const response = await axios.get(url);
        return response;
    } catch (error) {
        console.error("Error in axios Request:", error);
        throw error;
    }
};



export default { requestData, getFile, fetch };
